/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { KissOutboundStateInfo, KissService } from "app/services/kiss.service";

/**
 * Resolves the current state of a portal performing KISS's Outbound process.
 */
@Injectable({
  providedIn: 'root', // register as singleton service
})
export class KissOutboundStateResolver implements Resolve<KissOutboundStateInfo> {

  constructor(private kissService: KissService) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<KissOutboundStateInfo> {
    const portalId = route.paramMap.get('id');
    if (!portalId) {
      return null;
    }
    return await this.kissService.getOutboundState(portalId).toPromise();
  }
}
